const log = require("../shared_utils/log.js");
const { findTargetById } = require("../shared_utils/find-target.js");
const uuid = require("./utils/uuid.js");
const target = require("./target.js");

function getGlitchVariables(glitchApplication, fromTarget) {
  return glitchApplication.targetVarNames.map((v) => {
    const varName = v.name;
    const varType = v.type;
    let variable;
    if (varType === "list") {
      variable = fromTarget.lookupOrCreateList(uuid(), varName);
    } else {
      variable = fromTarget.lookupOrCreateVariable(uuid(), varName);
    }
    return { name: varName, value: variable.value, type: varType };
  });
}

module.exports = function store(state, emitter) {
  emitter.on("start-dragging-glitch-application", () => {
    log("start-dragging-glitch-application");
    state.draggingGlitchApplication = true;
    state.draggingGlitchOutOfPlayArea = false;
    emitter.emit("render");
  });
  emitter.on(
    "copy-glitch-application",
    (fromTargetId, toTargetId, glitchApplicationId) => {
      log(
        "copy-glitch-application",
        fromTargetId,
        toTargetId,
        glitchApplicationId
      );
      const glitchApplication = state.glitchApplications.find(
        (g) => g.id === state.selectedGlitchApplicationId
      );
      const fromTarget = findTargetById(state.vm, fromTargetId);
      const toTarget = findTargetById(state.vm, toTargetId);
      const glitchVariables = getGlitchVariables(glitchApplication, fromTarget);
      const isEffectsGlitch = glitchApplication.glitchId === "effects";
      let effectsState = null;
      emitter.emit("apply-glitch", glitchApplication.glitchId, toTarget.id);
      if (isEffectsGlitch) {
        effectsState = JSON.parse(JSON.stringify(fromTarget.effects));
        toTarget.effects = effectsState;
        for (const effect in effectsState) {
          toTarget.sprite.clones.forEach((c) => {
            c.setEffect(effect, effectsState[effect]);
          });
        }
      }

      glitchVariables.forEach((glitchVar) => {
        toTarget.sprite.clones.forEach((c) => {
          let v;
          if (glitchVar.type === "list") {
            v = c.lookupOrCreateList(uuid(), glitchVar.name);
          } else {
            v = c.lookupOrCreateVariable(uuid(), glitchVar.name);
          }
          v.value = glitchVar.value;
        });
      });
    }
  );

  emitter.on("end-dragging-glitch-application", (e) => {
    log("end-dragging-glitch-application", e);
    const keepOriginal = e.shiftKey;
    if (state.hoveringTargetId) {
      const glitchApplication = state.glitchApplications.find(
        (g) => g.id === state.selectedGlitchApplicationId
      );
      const { glitchId } = glitchApplication;
      const fromTarget = findTargetById(state.vm, glitchApplication.targetId);
      const fromTargetId = glitchApplication.targetId;
      const toTarget = state.vm.runtime.targets.find(
        (t) => t.id === state.hoveringTargetId
      );
      if (toTarget.sprite.clones[0].id !== fromTargetId) {
        const actionType = keepOriginal
          ? "copy-glitch-sticker"
          : "move-glitch-sticker";
        emitter.emit("push-history", actionType);
        emitter.emit(
          "copy-glitch-application",
          fromTarget.id,
          toTarget.id,
          glitchApplication.id
        );
        if (!keepOriginal) {
          emitter.emit("remove-glitch", glitchApplication.id);
        }
        emitter.emit("select-glitch-on-target", glitchId, toTarget.id);
      }
    }
  });
  emitter.on("drop-to-trash", () => {
    log("drop-to-trash");
    state.draggingGlitchSticker = false;

    // If we're dragging a piece out of the play area, delete the whole piece
    if (state.draggingTargetOutOfPlayArea) {
      emitter.emit("delete-selected-sprite");
    }
    // If we're dragging a glitch sticker
    else if (state.selectedGlitchApplicationId) {
      const glitchApplication = state.glitchApplications.find(
        (g) => g.id === state.selectedGlitchApplicationId
      );
      const targetId = glitchApplication.targetId;

      emitter.emit("delete-glitch", state.selectedGlitchApplicationId);
      emitter.emit("throw-glitch-in-trash", glitchApplication.glitchId);

      if (
        state.playingTutorial &&
        !state.toolbar.glitches.includes(glitchApplication.glitchId)
      ) {
        state.toolbar.glitches.push(glitchApplication.glitchId);
      }

      emitter.emit("push-history", "remove-glitch-application", {
        glitchId: glitchApplication.glitchId,
        targetId: glitchApplication.targetId,
      });

      emitter.emit(
        "remove-glitch",
        glitchApplication.id,
        state.selectedTargetId
      );

      // Find other non-physics glitches on this target
      const remainingGlitches = state.glitchApplications.filter(
        (g) => g.targetId === targetId && g.glitchId !== "builtin_physics"
      );

      // If there are remaining glitches, select the last one
      if (remainingGlitches.length > 0) {
        emitter.emit(
          "select-glitch-application",
          remainingGlitches[remainingGlitches.length - 1].id
        );
      } else {
        state.selectedGlitchApplicationId = null;
      }
    } else if (state.selectedGlitchId) {
      //remove glithch from toolbar
      emitter.emit("remove-glitch-from-toolbar", state.selectedGlitchId);
    }
  });
};
